export default "__VITE_ASSET__B_N8GGpS__"